import { StarsButton, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CMSAuthAction } from '@swf/cms';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';

import { TXTCLI_Deposit, TXTWCL_Welcome_to_N0 } from './AccountInfo.messages.json';
import styles from './AccountInfo.scss';
import AvatarIcon from './assets/avatar-icon.svg';
import BalanceDisplay from './components/BalanceDisplay';

const AccountInfo: React.FC = () => {
  const isSportsSelfExcluded = useSelector(select.account.isSportsSelfExcluded);
  const playChips = useSelector(select.account.getPlayChips);
  const isPlayMoney = useSelector(select.currency.isPlayMoney);
  const totalBalance = useSelector(select.account.getTotalBalance);
  const userId = useSelector(select.account.getUserId);
  const balance = isPlayMoney ? playChips : totalBalance;

  const isAuthenticated = useSelector(select.session.isAuthenticated);

  const { modal } = useDispatch<Dispatch>();

  const returnDepositButton = () =>
    !isSportsSelfExcluded && (
      <StarsButton
        className={styles.deposit}
        size="small"
        data-testid="deposit-button"
        href="/account/cashier/deposit"
        translation={TXTCLI_Deposit}
      />
    );

  const onAvatarClick = () => {
    if (isAuthenticated) {
      modal.enqueue({ path: '/account' });
    }
  };

  return (
    <div className={styles.container}>
      {/* TODO: After implementation of endpoint for recieve avatar image will be updated, till then use mock data  */}
      <AvatarIcon className={styles.avatar} onClick={onAvatarClick} />
      {!isAuthenticated && (
        <span className={styles.label}>
          <Translation {...TXTWCL_Welcome_to_N0} values={{ 0: 'PokerStars' }} />
        </span>
      )}
      {balance && userId && (
        <BalanceDisplay onUserNameClick={onAvatarClick} userId={userId} balance={balance} />
      )}
      <div className={styles.authWrapper}>
        {isAuthenticated ? returnDepositButton() : <CMSAuthAction />}
      </div>
    </div>
  );
};

export default AccountInfo;
